import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/views/layout/index'

Vue.use(Router)

/**
 * hidden: 是否显示在左侧菜单
 */

// 通用路由
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true }
]

export default new Router({
  routes: constantRouterMap
})

// 首页模板
export const dashboardRoute = {
  system: {
    name: 'dashboard-system',
    path: '',
    component: Layout,
    children: [
      {
        id: '1001',
        path: '',
        component: () => import('@/views/dashboard/system'),
        meta: { title: '首页', icon: 'dashboard', keepAlive: true }
      }
    ]
  },
  empty: {
    name: 'dashboard-empty',
    path: '',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/dashboard/empty'),
        meta: { title: '首页', icon: 'dashboard' }
      }
    ]
  }
}

export const headerServiceMap = [
  {
    path: '/Statistics',
    component: Layout,
    meta: { title: '数据统计', icon: 'permission' },
    children: [
      // {
      //   id: '8d4f6d248da74aaa84b80fba44faef5a',
      //   path: 'statistics-index',
      //   component: () => import('@/views/Statistics/index'),
      //   name: 'statistics-index',
      //   meta: { title: '数据统计', keepAlive: true }
      // },
      {
        id: '8d4f6d248da74aaa84b80fba44faef5a',
        path: 'user-data-analysis',
        component: () => import('@/views/Statistics/user-data-analysis'),
        name: 'user-data-analysis',
        meta: { title: '用户数据分析', keepAlive: true }
      },
      {
        id: '8d4f6d248da74aaa84b80fba44faef5a',
        path: 'charging-order-analysis',
        component: () => import('@/views/Statistics/charging-order-analysis'),
        name: 'charging-order-analysis',
        meta: { title: '充电订单分析', keepAlive: true }
      },
      {
        id: '8d4f6d248da74aaa84b80fba44faef5a',
        path: 'charging-order-data-analysis',
        component: () => import('@/views/Statistics/charging-order-data-analysis'),
        name: 'charging-order-data-analysis',
        meta: { title: '充值订单收入分析', keepAlive: true }
      },
      {
        id: '8d4f6d248da74aaa84b80fba44faef5a',
        path: 'monthly-card-order-data-analysis',
        component: () => import('@/views/Statistics/monthly-card-order-data-analysis'),
        name: 'monthly-card-order-data-analysis',
        meta: { title: '月卡订单数据分析', keepAlive: true }
      },
      {
        id: '8d4f6d248da74aaa84b80fba44faef5a',
        path: 'site-statistics',
        component: () => import('@/views/Statistics/site-statistics'),
        name: 'site-statistics',
        meta: { title: '网点统计', keepAlive: true }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    children: [
      {
        id: '8d4f6d248da74aaa84b80fba44faef5a',
        path: 'index',
        component: () => import('@/views/user/index'),
        name: 'user-index',
        meta: { title: '用户管理', icon: 'members', keepAlive: true }
      },
      {
        id: '8d4f6d248da74aaa84b80fba44faef5a',
        path: 'user-detail',
        component: () => import('@/views/user/user-detail'),
        name: 'user-detail',
        meta: { title: '用户详情' },
        hidden: true
      }
    ]
  },
  {
    path: '/site',
    component: Layout,
    meta: { title: '网点管理', icon: 'permission' },
    children: [
      {
        id: 'd80fd12ef7384be2b746a91b1dfb8bf9',
        path: 'site-type',
        component: () => import('@/views/site/site-type'),
        name: 'site-type',
        meta: { title: '网点类型' }
      },
      {
        id: '9b8b2e882ade42d1b48d2b0ba097de45',
        path: 'site-index',
        component: () => import('@/views/site/site-index'),
        name: 'site-index',
        meta: { title: '网点列表', keepAlive: true }
      },
      {
        id: '9b8b2e882ade42d1b48d2b0ba097de45',
        path: 'site-edit',
        component: () => import('@/views/site/site-edit'),
        name: 'site-edit',
        meta: { title: '网点详情' },
        hidden: true
      }
    ]
  },
  {
    path: '/shop',
    component: Layout,
    hidden: true,
    meta: { title: '商家', icon: 'permission' },
    children: [
      {
        id: '5862bdbce879489bbf719d8700845126',
        path: 'shop-index',
        component: () => import('@/views/shop/shop-index'),
        name: 'shop-index',
        meta: { title: '商家管理', icon: 'permission' },
        hidden: true
      },
      {
        id: '5862bdbce879489bbf719d8700845126',
        path: 'shop-detail',
        component: () => import('@/views/shop/shop-detail'),
        name: 'shop-detail',
        meta: { title: '商家详情' },
        hidden: true
      }
    ]
  },
  {
    path: '/monthly_card',
    component: Layout,
    meta: { title: '月卡管理', icon: 'permission' },
    children: [
      {
        id: '2ffe49f2adac4b24b3b99cedef9c4c3d',
        path: 'monthly_card-index',
        component: () => import('@/views/monthly_card/index'),
        name: 'monthly_card-index',
        meta: { title: '月卡管理', keepAlive: true }
      },
      {
        id: 'b32f257ca45d41488a4616d3c3c41047',
        path: 'monthly_card-records',
        component: () => import('@/views/monthly_card/records'),
        name: 'monthly_card-records',
        meta: { title: '开通记录', keepAlive: false }
      }
    ]
  },
  {
    name: 'electric_card',
    path: '/electric_card',
    component: Layout,
    children: [
      {
        id: '920a5bde2d7f49048c8e5de6debc278d',
        path: 'index',
        component: () => import('@/views/electric_card/index'),
        name: 'index',
        meta: { title: '电卡管理', icon: 'permission' }
      }
    ]
  },

  {
    path: '/partners',
    component: Layout,
    children: [
      {
        id: '5862bdbce879489bbf719d8700845126',
        path: 'partners-index',
        component: () => import('@/views/partners/partners-index'),
        name: 'partners-index',
        meta: { title: '合伙人管理', icon: 'permission', keepAlive: true }
      },
      {
        id: '5862bdbce879489bbf719d8700845126',
        path: 'partners-detail',
        component: () => import('@/views/partners/partners-detail'),
        name: 'partners-detail',
        meta: { title: '合伙人详情' },
        hidden: true
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    meta: { title: '订单管理', icon: 'permission' },
    children: [
      {
        id: '1c28c71d72e4476ba9b6fc5d0e60509e',
        path: 'order-index',
        component: () => import('@/views/order/order-index'),
        name: 'order-index',
        meta: { title: '充电订单', keepAlive: true }
      },
      {
        id: '1c28c71d72e4476ba9b6fc5d0e60509e',
        path: 'order-detail',
        component: () => import('@/views/order/order-detail'),
        name: 'order-detail',
        meta: { title: '订单详情' },
        hidden: true
      },
      {
        id: '229b5276736e42c59f07822a99fdd4cb',
        path: 'abnormal-order',
        component: () => import('@/views/order/abnormal-order'),
        name: 'abnormal-order',
        meta: { title: '充电异常订单', keepAlive: true }
      },
      {
        id: '494943a2ffa84ec1a88408b41483fcca',
        path: 'recharge-order',
        component: () => import('@/views/order/recharge-order'),
        name: 'recharge-order',
        meta: { title: '充值订单', keepAlive: true }
      },
      {
        id: '494943a2ffa84ec1a88408b41483fcca',
        path: 'user-withdrawal-order',
        component: () => import('@/views/order/user-withdrawal-order'),
        name: 'user-withdrawal-order',
        meta: { title: '用户提现订单', keepAlive: true }
      }
    ]
  },
  {
    path: '/finance',
    component: Layout,
    meta: { title: '财务管理', icon: 'permission' },
    children: [
      {
        id: '680a8171c8584a92938877dce6aa34e8',
        path: 'finance-index',
        component: () => import('@/views/finance/index'),
        name: 'finance-index',
        meta: { title: '合伙人提现', keepAlive: true }
      },
      {
        id: '0d1ff543079c40fe98c64008096a2a04',
        path: 'err-list',
        component: () => import('@/views/finance/err-list'),
        name: 'err-list',
        meta: { title: '合伙人提现异常', keepAlive: true }
      },
      {
        id: '02e74f10e0327ad868d138f2b4fdd6f0',
        path: 'use-withdrawal',
        component: () => import('@/views/finance/use-withdrawal'),
        name: 'use-withdrawal',
        meta: { title: '用户提现', keepAlive: true }
      }
    ]
  },
  {
    path: '/equipment',
    component: Layout,
    meta: { title: '设备管理', icon: 'permission' },
    children: [
      {
        id: 'dd0f9545c2884cb8adfd4d0ff314dc76',
        path: 'equipment-index',
        component: () => import('@/views/equipment/equipment-index'),
        name: 'equipment-index',
        meta: { title: '批次管理', keepAlive: true }
      },
      {
        id: 'e2ab3e20a2024dd2bebd80c1b79f1b66',
        path: 'equipment-list',
        component: () => import('@/views/equipment/equipment-list'),
        name: 'equipment-list',
        meta: { title: '设备列表' }
      },
      {
        id: '366492ef99ab48edbb295a74b8db4cfc',
        path: 'error-list',
        component: () => import('@/views/equipment/error-list'),
        name: 'error-list',
        meta: { title: '异常设备' }
      },
      {
        id: '366492ef99ab48edbb295a74b8db4cfc',
        path: 'ota-list',
        component: () => import('@/views/equipment/ota-list'),
        name: 'ota-list',
        meta: { title: '设备升级文件' }
      }
    ]
  },
  {
    path: '/help-center',
    component: Layout,
    meta: { title: '帮助中心设置', icon: 'permission' },
    children: [
      {
        id: 'b5e225c7529d43dea9af4f10193799de',
        path: 'question-type',
        component: () => import('@/views/help-center/question-type'),
        name: 'question-type',
        meta: { title: '问题分类', keepAlive: true }
      },
      {
        id: '4d1510044aa2418ba41da9fbbeb419e4',
        path: 'question-list',
        component: () => import('@/views/help-center/question'),
        name: 'question-list',
        meta: { title: '问题管理', keepAlive: true }
      }
    ]
  },
  {
    path: '/feedback',
    component: Layout,
    meta: { title: '反馈管理', icon: 'permission' },
    children: [
      {
        id: '673fbcfc2a484cc193b6c8a801c509fd',
        path: 'user-feedback',
        component: () => import('@/views/feedback/user-feedback'),
        name: 'user-feedback',
        meta: { title: '用户反馈', keepAlive: true }
      },
      {
        id: 'e428b51fbe5b456d9c08124313fd006f',
        path: 'need-feedback',
        component: () => import('@/views/feedback/need-feedback'),
        name: 'need-feedback',
        meta: { title: '需求反馈', keepAlive: true }
      }
    ]
  },
  {
    path: '/banners',
    component: Layout,
    children: [
      {
        id: '4a9215251577430f80b323e0cdde11c9',
        path: 'index',
        component: () => import('@/views/banners/index'),
        name: 'banners-index',
        meta: { title: '轮播图管理', icon: 'banners', keepAlive: true }
      },
      {
        id: '4a9215251577430f80b323e0cdde11c9',
        path: 'create',
        component: () => import('@/views/banners/submit-form'),
        name: 'banners-create',
        meta: { title: '轮播图创建' },
        hidden: true
      },
      {
        id: '4a9215251577430f80b323e0cdde11c9',
        path: 'edit/:id',
        component: () => import('@/views/banners/submit-form'),
        name: 'banners-edit',
        meta: { title: '轮播图编辑' },
        hidden: true
      }
    ]
  }
]

export const footerServiceMap = [
  {
    name: 'permission',
    path: '/permission',
    component: Layout,
    meta: { title: '权限', icon: 'permission' },
    children: [
      {
        id: '47a5948d734646e8a257a09d12fcbc51',
        path: 'admin',
        component: () => import('@/views/system/admin'),
        name: 'system-admin',
        meta: { title: '管理用户' }
      },
      {
        id: 'a3a526a533704aabaec00c6a34dc4f53',
        path: 'role',
        component: () => import('@/views/system/role'),
        name: 'system-role',
        meta: { title: '角色权限' }
      },
      {
        id: 'a2aa56fc52d747e5abcc877e23e798be',
        path: 'withdraw-pwd',
        component: () => import('@/views/system/withdraw-pwd'),
        name: 'withdraw-pwd',
        meta: { title: '提现密码' }
      }
    ]
  },
  {
    name: 'message',
    path: '/message',
    component: Layout,
    children: [
      {
        id: '24e8d620d39946e7a7c62fecad9a7a8b',
        path: 'index',
        component: () => import('@/views/message/index'),
        name: 'message-index',
        meta: { title: '系统消息管理', icon: 'setting' }
      }
    ]
  },
  {
    name: 'recharge-package',
    path: '/recharge-package',
    component: Layout,
    children: [
      {
        id: '24e8d620d39946e7a7c62fecad9a7a8b',
        path: 'index',
        component: () => import('@/views/recharge-package/index'),
        name: 'recharge-package-index',
        meta: { title: '充值套餐', icon: 'setting' }
      }
    ]
  },
  {
    name: 'setting',
    path: '/setting',
    component: Layout,
    children: [
      {
        id: 'f6755f57a1e64df1ad98f960613e4940',
        path: 'index',
        component: () => import('@/views/setting/index'),
        name: 'setting-index',
        meta: { title: '参数管理', icon: 'setting' }
      }
    ]
  },
  {
    name: 'marketing',
    path: '/marketing',
    component: Layout,
    children: [
      {
        id: '3e981d13607d4ae4878c541e93a755cb',
        path: 'index',
        component: () => import('@/views/marketing/index'),
        name: 'marketing-index',
        meta: { title: '营销管理', icon: 'setting' }
      }
    ]
  }
]
